import { Button, CheckLineIcon } from 'ui';

const CompleteNowItem = () => (
  <Button icon={<CheckLineIcon />} size="small" type="primary">
    Complete now
  </Button>
);

export default CompleteNowItem;
